import { EditorialTemplate } from "../../domain/domain";

export function createTemplateEditorPlugin(templates: EditorialTemplate[]): any {
    let plugin: any = {
        name: 'template_editor',
        title: 'Templates',
        display: 'submenu',
        innerHTML: `<div className='header-button'>Templates</div>`,
        buttonClass: 'header-button-wrapper',
        templates: templates,
        add: function (core: any, targetElement: any) {
            const context = core.context;
            context.templates = templates;
            context.font = {
                targetText: targetElement.querySelector('.txt'),
                targetTooltip: targetElement.parentNode.querySelector('.se-tooltip-text'),
                _fontList: null,
                currentFont: ''
            };

            /** set submenu */
            let listDiv = this.setSubmenu(core);

            /** add event listeners */
            listDiv.querySelector('.se-list-inner').addEventListener('click', this.pickup.bind(core));

            context.font._fontList = listDiv.querySelectorAll('ul li button');

            /** append target button menu */
            core.initMenuTarget(this.name, targetElement, listDiv);

            /** empty memory */
            listDiv = null;
        },
        setSubmenu: function (core: any) {
            const listDiv = core.util.createElement('p');
            listDiv.className = 'se-submenu se-list-layer se-list-font-family';
            let list = '<div class="se-list-inner">' +
                '<ul class="se-list-basic">';
            for (let i = 0, len = templates.length; i < len; i++) {
                list += '<li><button type="button" class="se-btn-list btn-template-list" data-value="' + templates[i].id + '" title="' + templates[i].title + '" aria-label="' + templates[i].title + '">' + templates[i].title + '</button></li>';
            }
            list += '</ul></div>';
            listDiv.innerHTML = list;
            return listDiv;
        },
        pickup: function (e: any) {
            if (!/^BUTTON$/i.test(e.target.tagName)) return false;

            e.preventDefault();
            e.stopPropagation();

            const value = e.target.getAttribute('data-value');

            let template = templates.find(t => t.id === value);
            if (!template) {
                return;
            }

            if (value) {
                const newNode = this.util.createElement('p');
                newNode.innerHTML = template.content;
                this.insertNode(newNode, this.getSelectionNode(), true);
            }
            this.submenuOff();
        }
    }
    return plugin;
}